import { COLLECTIONS } from "../../core/collections";
import { getDbOrThrow, col } from "../../core/firestoreCore";
import { getDocs } from "firebase/firestore";
import { getOrFetch, invalidate as _invalidate } from "../../cache/getOrFetch";

const TTL_INTAX_CONFIG =
  Number(process.env.REACT_APP_TTL_SYSTEM_INTAX_MS) ||
  Number(process.env.REACT_APP_TTL_INTAX_MS) ||
  7 * 24 * 60 * 60 * 1000;

export async function _fetchSystemInTaxConfigOnceNoCache() {
  console.info("[InTax] fetch system config (noCache) …");
  const db = getDbOrThrow();                          // same bootstrap used elsewhere
  const base = col(db, COLLECTIONS.systemIncomeTaxConfig);
  const snap = await getDocs(base);
  console.info("[InTax] system config query size:", snap.size);

  const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  if (!rows.length) {
    console.warn(`[InTax] "${COLLECTIONS.systemIncomeTaxConfig}" returned 0 docs.`);
  } else {
    // light touch: show first country names if present
    try {
      const countries = rows[0]?.countries?.map?.((c) => c.name) || [];
      console.info("[InTax] sample countries:", countries.join(", "));
    } catch {}
  }
  return rows;
}

export function fetchSystemInTaxConfigOnce(opts = {}) {
  if (opts?.noCache) return _fetchSystemInTaxConfigOnceNoCache();

  const key = "intax:system-config";
  return getOrFetch({
    key,
    ttlMs: opts.ttlMs ?? TTL_INTAX_CONFIG,
    persist: true,
    persistKey: key,
    fetcher: _fetchSystemInTaxConfigOnceNoCache,
  });
}

export function invalidateInTaxSystemConfigCache() {
  console.info("[InTax] invalidating system config cache");
  _invalidate("intax:system-config");
}
